export const geoipProps = {
  image: {
    type: Object,
    default: () => ({}),
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  countries: {
    type: Array,
    required: true,
  },
  cookieExpiration: {
    type: String,
    default: '3m',
  },
  redirectLabel: {
    type: String,
    required: true,
  },
  continueLabel: {
    type: String,
    required: true,
  },
  defaultCountryCode: {
    type: String,
    required: true,
  },
  btnBgColor: {
    type: String,
    default: '',
  },
  btnTextColor: {
    type: String,
    default: '',
  },
};
